var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loginFormActive
    ? _c("div", { staticClass: "login-form login-subform.vue" }, [
        _c(
          "div",
          { staticClass: "inner-form" },
          [
            _c(
              "b-form-group",
              {
                staticClass: "username-group",
                attrs: {
                  state: _vm.usernameState,
                  "invalid-feedback": _vm.usernameInvalid,
                },
              },
              [
                _c(
                  "b-input-group",
                  [
                    _c(
                      "b-input-group-text",
                      { attrs: { slot: "prepend" }, slot: "prepend" },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: _vm.userIcon },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("b-form-input", {
                      ref: "username",
                      attrs: {
                        type: "text",
                        "data-cy": "login-form-username",
                        placeholder: "Email",
                        autocomplete: "email",
                        required: "",
                      },
                      on: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.loginEnterKey.apply(null, arguments)
                        },
                        focus: function ($event) {
                          _vm.focusField = "username"
                        },
                      },
                      model: {
                        value: _vm.username,
                        callback: function ($$v) {
                          _vm.username = $$v
                        },
                        expression: "username",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                staticClass: "password-group",
                attrs: {
                  state: _vm.passwordState,
                  "invalid-feedback": _vm.passwordInvalid,
                },
              },
              [
                _c(
                  "b-input-group",
                  [
                    _c(
                      "b-input-group-text",
                      { attrs: { slot: "prepend" }, slot: "prepend" },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: _vm.lockIcon },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("b-form-input", {
                      ref: "password",
                      attrs: {
                        type: _vm.passwordFieldType,
                        "data-cy": "login-form-password",
                        placeholder: "Password",
                        autocomplete: "current-password",
                        required: "",
                      },
                      on: {
                        focus: function ($event) {
                          _vm.focusField = "password"
                        },
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.loginEnterKey.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.password,
                        callback: function ($$v) {
                          _vm.password = $$v
                        },
                        expression: "password",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "b-input-group-text",
                      {
                        staticClass: "show-password",
                        attrs: { slot: "append" },
                        on: { click: _vm.togglePasswordVisibility },
                        slot: "append",
                      },
                      [
                        _vm.passwordHidden
                          ? _c(
                              "div",
                              {
                                staticClass: "password-hidden",
                                attrs: { title: "Show Password" },
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: _vm.eyeIcon },
                                }),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              {
                                staticClass: "password-shown",
                                attrs: { title: "Hide Password" },
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: _vm.eyeSlashIcon },
                                }),
                              ],
                              1
                            ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "submit",
                attrs: {
                  disabled: _vm.loginFormValid,
                  "data-cy": "login-form-button",
                  variant: "primary",
                  type: "submit",
                },
                on: { click: _vm.onLoginSubmit },
              },
              [_vm._v("\n      Log In\n    ")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "login-actions" }, [
          !_vm.hideForgotPassword
            ? _c(
                "div",
                {
                  staticClass: "login-action",
                  attrs: { "data-cy": "login-form-recover-password" },
                  on: {
                    click: function ($event) {
                      return _vm.changeRoute("/password/request")
                    },
                  },
                },
                [_vm._v("\n      Forgot Password\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.hideCreateAccount
            ? _c(
                "div",
                {
                  staticClass: "login-action",
                  attrs: { "data-cy": "login-form-create-account" },
                  on: {
                    click: function ($event) {
                      return _vm.changeRoute(_vm.registerAccountLink)
                    },
                  },
                },
                [_vm._v("\n      Create New Account\n    ")]
              )
            : _vm._e(),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }